"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { createStripePortalAction } from "@/data/payment/actions/createStripePortalAction";
import { logError } from "@/utils/logError";

export function UpdatePaymentMethodButton() {
  const router = useRouter();

  const [isLoading, setIsLoading] = useState(false);

  const updatePaymentMethod = async () => {
    try {
      setIsLoading(true);
      const stripePortalUrl = await createStripePortalAction({
        typeOfPortal: "paymentMethodUpdate",
        stripeIdPriceForSubscriptionUpdateConfirm: null,
      });

      if (stripePortalUrl !== null) {
        router.push(stripePortalUrl);
      }
    } catch (error) {
      console.error("Could not update payment method", error);
      logError("Could not update payment method");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button onClick={updatePaymentMethod} loading={isLoading}>
      Update payment method
    </Button>
  );
}
